import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FileText, X, Minus, Square } from 'lucide-react';
import { playSound, SOUNDS } from '../App';

export default function ReadmeWindow({ 
  zIndex, 
  onClose, 
  onMinimize, 
  onFocus,
  position = { x: 140, y: 80 },
  onPositionChange 
}) {
  const [isMaximized, setIsMaximized] = useState(false);

  const windowStyle = isMaximized
    ? { zIndex, left: 0, top: 0, width: '100%', height: 'calc(100vh - 36px)' }
    : { zIndex, left: position.x, top: position.y, width: '500px' };

  return (
    <motion.div
      className="win-window"
      style={{ ...windowStyle, position: 'fixed' }}
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
      transition={{ duration: 0.15 }}
      onClick={onFocus}
      drag={!isMaximized}
      dragMomentum={false}
      dragElastic={0}
      dragConstraints={{ left: -400, right: 1200, top: 0, bottom: 600 }}
      onDragEnd={(event, info) => {
        if (!isMaximized) {
          onPositionChange?.({
            x: Math.max(0, position.x + info.offset.x),
            y: Math.max(0, position.y + info.offset.y)
          });
        }
      }}
    >
      <div className="win-window-header">
        <div className="win-window-title">
          <FileText size={14} />
          README.txt - Notepad
        </div>
        <div className="win-window-controls">
          <button className="win-ctrl-btn" onClick={(e) => { e.stopPropagation(); playSound(SOUNDS.click); onMinimize(); }}>
            <Minus size={10} />
          </button>
          <button className="win-ctrl-btn" onClick={(e) => { e.stopPropagation(); setIsMaximized(!isMaximized); }}>
            <Square size={8} />
          </button>
          <button className="win-ctrl-btn win-close" onClick={(e) => { e.stopPropagation(); playSound(SOUNDS.windowClose); onClose(); }}>
            <X size={10} />
          </button>
        </div>
      </div>

      {/* Notepad Menu Bar */}
      <div className="notepad-menu">
        <span className="menu-item"><u>F</u>ile</span>
        <span className="menu-item"><u>E</u>dit</span>
        <span className="menu-item"><u>S</u>earch</span>
        <span className="menu-item"><u>H</u>elp</span>
      </div>
      
      <div className="win-window-body notepad-body">
        <div className="notepad-content">
{`═══════════════════════════════════════════════════
     AUTONOMOUS - README
     Oslo, Norway | Est. 2024
═══════════════════════════════════════════════════

WELCOME!
--------
You've just booted into Autonomous 95.

We build AI systems that WORK:
  • Ships in weeks, not quarters
  • 99.7% uptime guaranteed  
  • Zero failed pilots
  • Runs autonomously


QUICK START:
------------
• Double-click [services.exe] - See what we build
• Double-click [metrics.sys] - Our track record
• Double-click [contact.msg] - Start a conversation
• Double-click [about.txt] - Our story


FUN STUFF:
----------
• Try Minesweeper - Take a break!
• Open CMD - Type "matrix" for a surprise
• Right-click desktop - More options
• Wait 2 minutes - Screen saver!
• Konami code - ↑↑↓↓←→←→BA


CONTACT:
--------
Ready to build AI that actually works?
Double-click contact.msg or visit our website.

───────────────────────────────────────────────────
© 2025 Autonomous AS. All rights reserved.
───────────────────────────────────────────────────`}
        </div>
      </div>
    </motion.div>
  );
}
